import { useState } from "react";
import { useTranslation } from "react-i18next";
import AppInputNew from "@/components/Core/AppInput/AppInputNew";
import Button from "@/components/Core/Button/Button";
import { INVOICE_EXPORT_TYPE_LABELS } from "@/models/Organisation";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

const FaktureringPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();
	const [accountNumber, setAccountNumber] = useState(
		organisation?.invoiceSettings?.accountNumber || ""
	);

	function save() {
		if (organisation?.invoiceSettings) {
			updateOrganisation({
				invoiceSettings: { ...organisation.invoiceSettings, accountNumber },
			});
		}
	}

	return (
		<SettingsLeaf title="Fakturering">
			<AppInputNew
				label="Faktureringssystem"
				value={
					organisation?.invoiceSettings?.exportType
						? INVOICE_EXPORT_TYPE_LABELS[organisation.invoiceSettings.exportType] ??
							organisation.invoiceSettings.exportType
						: ""
				}
				disabled
				description="Ekonomisystem som Origo integrerar mot för att skapa och skicka fakturor. Kontakta Origo om ni önskar integrera mot ett annat system."
			/>
			<div className="space-y-2">
				<AppInputNew
					label="Kontonummer vid fakturering"
					value={accountNumber}
					onChangeText={setAccountNumber}
					description="Kontonummer som används vid export av fakturor."
				/>
				<Button onClick={save}>{t("SAVE")}</Button>
			</div>
		</SettingsLeaf>
	);
};

export default FaktureringPage;
